import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const [selected, setSelected] = useState("all");

  const orgAdmin = user && ["OWNER", "SUPER_ADMIN"].includes(user.role);
  const multiBranch = user && (orgAdmin || (Array.isArray(user.branch_ids) && user.branch_ids.length > 1));
  const allowAll = !!multiBranch;
  const allLabel = orgAdmin ? "All Branches" : "All Assigned Branches";

  useEffect(() => {
    if (!user) return;
    api.get("/branches").then((r) => {
      setBranches(r.data);
      if (multiBranch) setSelected("all");
      else if (r.data[0]) setSelected(r.data[0].id);
    });
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const branchParam = selected === "all" ? undefined : selected;

  return (
    <BranchContext.Provider value={{ branches, selected, setSelected, branchParam, allowAll, allLabel }}>
      {children}
    </BranchContext.Provider>
  );
}

export const useBranch = () => useContext(BranchContext);
